import { withViewModel } from '@hooks/useViewModel';
import RHFCheckboxSelect from './RHFCheckboxSelect';
import useRHFCheckboxSelect from './useRHFCheckboxSelect';

const CheckboxAutocompleteContainer = withViewModel(RHFCheckboxSelect, useRHFCheckboxSelect);

export default CheckboxAutocompleteContainer;
